module.exports = __webpack_public_path__ + "dimer/static/img/10.5886e52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/globalPartner/10.jpg
// module id = 5TwM
// module chunks = 0